module.exports = __webpack_public_path__ + "static/media/email.c5b0c6ef.svg";